import { BrowserRouter } from 'react-router-dom';
import { StatusModalProvider } from '@shared/context/StatusModalContext';
import { AppRouter } from './router/AppRouter';
import { AppProvider } from './providers/AppProvider';

export const App = () => {
  return (
    <AppProvider>
      <BrowserRouter>
        <StatusModalProvider>
          <AppRouter />
        </StatusModalProvider>
      </BrowserRouter>
    </AppProvider>
  );
};

